import React, { useState } from 'react';
import {
  Stack,
  Button,
  TextField,
  IconButton,
  Typography
} from '@mui/material';
import {
  Email as EmailIcon,
  WhatsApp as WhatsAppIcon,
  Facebook as FacebookIcon,
  ContentCopy as CopyIcon,
  QrCode as QrCodeIcon
} from '@mui/icons-material';
import QRCodeModal from './QRCodeModal';

const ShareSection = ({
  activeUser,
  userProfile,
  copied,
  onCopyToClipboard,
  onShareViaEmail,
  onShareViaWhatsApp,
  onShareViaFacebook
}) => {
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const salonUrl = `${window.location.origin}/salon/${activeUser?.uid}`;

  const handleQRCodeClick = () => {
    setQrModalOpen(true);
  };

  return (
    <Stack spacing={2}>
      <TextField
        fullWidth
        value={salonUrl}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <IconButton onClick={onCopyToClipboard} edge="end">
              <CopyIcon />
            </IconButton>
          )
        }}
        size="small"
        label="Votre lien"
      />

      <Stack spacing={1}>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<QrCodeIcon />}
          onClick={handleQRCodeClick}
          sx={{ color: '#6B46C1', borderColor: '#6B46C1' }}
        >
          Mon QR Code
        </Button>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<EmailIcon />}
          onClick={onShareViaEmail}
        >
          Partager par email
        </Button>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<WhatsAppIcon />}
          onClick={onShareViaWhatsApp}
          sx={{ color: '#25D366', borderColor: '#25D366' }}
        >
          WhatsApp
        </Button>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<FacebookIcon />}
          onClick={onShareViaFacebook}
          sx={{ color: '#1877F2', borderColor: '#1877F2' }}
        >
          Facebook
        </Button>
      </Stack>

      <QRCodeModal
        open={qrModalOpen}
        onClose={() => setQrModalOpen(false)}
        salonUrl={salonUrl}
        salonName={userProfile?.salonName}
        onCopyToClipboard={onCopyToClipboard}
      />
    </Stack>
  );
};

export default ShareSection;